import * as React from "react";
import { useTranslation } from "react-i18next";

import PlusIcon from "components/icons/PlusIcon";
import ManageWorkflowWrapper from "components/workflows/manage-workflow-dialog/ManageWorkflowWrapper";
import WorkflowEditorV3View, { InitialTab } from "components/workflows/workflow-editor-v3/WorkflowEditorV3View";
import { UserDetails } from "domain/user";
import { WorkflowEntityType } from "domain/workflows";
import { Action, Category, usageStatisticsService } from "services/statistics/UsageStatisticsService";
import { workflowService } from "services/workflows/WorkflowService";
import buttons from "styles/buttons.scss";

import testIds from "testIds.json";

interface Props {
    user: UserDetails | null;
    onUpdate: () => void;
}

const CreateWorkflowView: React.FunctionComponent<Props> = (props) => {
    const { t } = useTranslation();
    const [createWorkflowVisibility, setCreateWorkflowVisibility] = React.useState(false);
    const [showEditorV3, setShowEditorV3] = React.useState(false);
    const [editorV3Tabs, setEditorV3Tabs] = React.useState<InitialTab[] | undefined>(undefined);

    const showCreateWorkflow = () => {
        usageStatisticsService.sendEvent({
            category: Category.WORKFLOW,
            action: Action.ADD_WORKFLOW,
        });
        setCreateWorkflowVisibility(true);
    };
    return (
        <>
            <button
                className={buttons.primaryButton}
                onClick={showCreateWorkflow}
                data-testid={testIds.workArea.workflows.createWorkflowButton}
            >
                <PlusIcon /> {t("WorkflowsTable.actions.create.button")}
            </button>
            <WorkflowEditorV3View
                isOpen={showEditorV3}
                onClose={() => setShowEditorV3(false)}
                initialTabs={editorV3Tabs}
                entityType={WorkflowEntityType.WORKFLOW}
            />
            <ManageWorkflowWrapper
                modalTitle={"ManageWorkflowDialog.title.create"}
                modalVisibility={createWorkflowVisibility}
                onUpdate={props.onUpdate}
                workflowService={workflowService}
                user={props.user}
                onShowModal={setCreateWorkflowVisibility}
                onOpenWithV3={(initialTabs) => {
                    setCreateWorkflowVisibility(false);
                    setEditorV3Tabs(initialTabs);
                    setShowEditorV3(true);
                }}
                isCreate={true}
                entityType={WorkflowEntityType.WORKFLOW}
            />
        </>
    );
};

export default CreateWorkflowView;
